// import { ButtonConfirm } from "core/components/form-controls";
// import Image from "core/components/Image";
import Icon from 'core/assets/icons';
import type { TIngredient } from "./../../store/types";
import { formatDate } from "core/utils/helper";

const MyIngredientItem = ({
  isSelected,
  ingredient,
  onSelectIngredient,
  onRemoveMyIngredients,
}: {
  isSelected: boolean,
  ingredient: TIngredient,
  onSelectIngredient: (ingredient: TIngredient) => void,
  onRemoveMyIngredients?: (ingredient: TIngredient) => void,
}) => {

  const removeIngredient = (ingredient: TIngredient) => {
    onRemoveMyIngredients?.(ingredient)
  }

  return (
    <div
      className={`
        px-3.5 py-[7px] rounded-lg cursor-pointer border relative mb-[10px]
        ${isSelected ? 'bg-orange-50 border-primary' : 'bg-white'}
      `}
    >
      <div className="absolute right-1 top-1">
        <img
          src={Icon.RecipeRemove}
          alt="remove"
          onClick={() => removeIngredient(ingredient)}
        />
      </div>
      <div
        key={ingredient.id}
        className="flex items-center cursor-pointer h-full"
        onClick={() => onSelectIngredient(ingredient)}
      >
        {/*<Image
          className="w-[40px] h-[40px] rounded object-cover mr-2"
          src={ingredient.image}
          alt={ingredient.name}
        />*/}
        <div className="h-full flex flex-col justify-between">
          <label className="block font-medium text-[13px] cursor-pointer tracking-tighter">
            {ingredient.name}
          </label>
          <span className="text-[#777777] text-[11px] tracking-tighter">
            {formatDate(ingredient.created_at, 'YY.MM.DD')}
          </span>
        </div>
      </div>
    </div>
  )
}

export default MyIngredientItem
